// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Sqq6","title":"Info_title__2W1zs","links":"Info_links__1xwuU","link":"Info_link__1a43I","logo":"Info_logo__3ky9H"};